export enum ReviewType {
  GROUP = 'GROUP',
  PERSONAL_MENTOR = 'PERSONAL_MENTOR',
}
